import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_grey.png'


const _withScopeId = n => (_pushScopeId("data-v-0735bf08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "theSecondaryMenu",
  class: "d-flex justify-content-between align-items-center bg-light px-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "DP logo",
  title: "DP logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "menu d-flex justify-content-end align-items-center me-3" }
const _hoisted_4 = { class: "d-flex align-items-center lh-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-2" }, "tips_and_updates", -1))
const _hoisted_6 = {
  key: 1,
  href: "https://youtu.be/QYGp2ULhkRY",
  target: "_blank",
  class: "me-4 fw-700 text-decoration-none"
}
const _hoisted_7 = { class: "d-flex align-items-center lh-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mas me-2" }, "play_circle", -1))
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas ms-2" }, "content_copy", -1))
const _hoisted_11 = {
  key: 3,
  class: "domain d-flex align-items-center"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "content_copy", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "dropdown user-dropdown ms-5" }
const _hoisted_17 = {
  type: "button",
  class: "btn btn-link dropdown-toggle text-decoration-none",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "key", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "code", -1))
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "switch_account", -1))
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "switch_account", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "logout", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "login", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserModeBadge = _resolveComponent("UserModeBadge")!
  const _component_BaseModalButton = _resolveComponent("BaseModalButton")!
  const _component_AppDrawer = _resolveComponent("AppDrawer")!
  const _component_LocaleChanger = _resolveComponent("LocaleChanger")!
  const _component_UserModeDialog = _resolveComponent("UserModeDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: 'home' },
      class: "logo"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.AbilityContext.isAuthorizedForFeature('DP_REF_PRICE_SETTINGS'))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'base-prices' },
                  class: "me-4 fw-700 text-decoration-none"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("adjustReferencePrices")), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.AbilityContext.isAuthorizedForFeature('DP_REF_PRICE_SETTINGS'))
              ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("instructionVideoReferencePrices")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.AuthContext.isDpUser())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
            _ctx.UtilityHelper.copyToClipboard(_ctx.CustomerContext.getCustomerCode())
          ), ["prevent"])),
                  title: _ctx.$t('copyToClipboard'),
                  class: "btn btn-icon text-green text-end lh-1 me-3"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.CustomerContext.getCustomerCode()) + " ", 1),
                  _hoisted_10
                ], 8, _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.customerMainDomain?.domain_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("a", {
                    href: 'https://' + _ctx.customerMainDomain.domain_url,
                    target: "_blank",
                    class: "text-decoration-none text-end lh-1 me-1"
                  }, _toDisplayString(_ctx.CustomerContext.getMainDomain()), 9, _hoisted_12),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
              _ctx.UtilityHelper.copyToClipboard(
                'https://' + _ctx.customerMainDomain.domain_url
              )
            ), ["prevent"])),
                    title: _ctx.$t('copyToClipboard'),
                    class: "btn btn-icon btn-sm text-primary"
                  }, _hoisted_15, 8, _hoisted_13)
                ]))
              : _createCommentVNode("", true),
            (_ctx.AuthContext.isUserMode())
              ? (_openBlock(), _createBlock(_component_UserModeBadge, {
                  key: 4,
                  class: "ms-5"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.$t("hello")) + " " + _toDisplayString(_ctx.AuthContext.getFullName()), 1),
              _createElementVNode("ul", _hoisted_18, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "dropdown-item",
                    to: { name: 'profile-password' }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19,
                      _createTextVNode(_toDisplayString(_ctx.$t("changePassword")), 1)
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.AuthContext.isDpUser(true))
                  ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                      _createElementVNode("a", {
                        class: "dropdown-item cu-p text-green",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'support-debug' })), ["prevent"]))
                      }, [
                        _hoisted_21,
                        _createTextVNode("Debug support ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.AuthContext.isDpUser(true) && !_ctx.AuthContext.isUserMode())
                  ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                      _createVNode(_component_BaseModalButton, {
                        class: "dropdown-item cu-p",
                        "modal-id": _ctx.userModeDialogId
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _createTextVNode(_toDisplayString(_ctx.$t("startUserMode")), 1)
                        ]),
                        _: 1
                      }, 8, ["modal-id"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.AuthContext.isUserMode())
                  ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                      _createElementVNode("a", {
                        class: "dropdown-item cu-p",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.leaveUserMode && _ctx.leaveUserMode(...args)), ["prevent"]))
                      }, [
                        _hoisted_25,
                        _createTextVNode(_toDisplayString(_ctx.$t("leaveUserMode")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    class: "dropdown-item cu-p",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                  }, [
                    _hoisted_26,
                    _createTextVNode(_toDisplayString(_ctx.$t("logout")), 1)
                  ])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (!_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
            class: "btn btn-icon btn-primary"
          }, [
            _hoisted_27,
            _createTextVNode(_toDisplayString(_ctx.$t("login")), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_AppDrawer, {
        "current-app": _ctx.AppEnum.MGMT,
        class: "ms-3"
      }, null, 8, ["current-app"]),
      _createVNode(_component_LocaleChanger, { class: "locale-changer ms-3 py-1" })
    ]),
    (_ctx.isAuthenticated && _ctx.AuthContext.isDpUser(true) && !_ctx.AuthContext.isUserMode())
      ? (_openBlock(), _createBlock(_component_UserModeDialog, {
          key: 0,
          "modal-id": _ctx.userModeDialogId
        }, null, 8, ["modal-id"]))
      : _createCommentVNode("", true)
  ]))
}